export const PAGE_NAME = 'home';
export const PAGE_KEY = 'dashboard';